import { Navbar } from '@/components/Navbar';
import { HeroSection } from '@/components/HeroSection';
import { WaterSection } from '@/components/WaterSection';
import { SailingSection } from '@/components/SailingSection';
import { NewsCarouselSection } from '@/components/NewsCarouselSection';
import { LakeSection } from '@/components/LakeSection';
import { GallerySection } from '@/components/GallerySection';
import { ContactSection } from '@/components/ContactSection';
import { Footer } from '@/components/Footer';

export function Index() {
  return (
    <div className="min-h-screen bg-white text-text-primary">
      <Navbar />
      <main>
        <HeroSection />
        <WaterSection />
        <SailingSection />
        <NewsCarouselSection />
        <LakeSection />
        <GallerySection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
